"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_COLORS = exports.TABLE_CONFIG = exports.SORT_BY_VALUES = exports.DEFAULT_LOCATION_ID = void 0;
var TABLE_CONFIG = exports.TABLE_CONFIG = {
  DAYS_TO_SHOW: 7,
  SCROLL_OFFSET: 7,
  MAX_BACKWARD_DAYS: 0,
  SKELETON_ROWS_COUNT: 20,
  PAGE_SIZE: 20,
  LAZY_LOAD_PAGE_SIZE: 20
};
var THEME_COLORS = exports.THEME_COLORS = {
  headerBg: '#FFFFFF',
  sortedBg: '#F8F8F8',
  sortedHoverBg: '#00000026',
  hoverBg: '#F8F8F8',
  priceColor: '#285E61',
  disabledColor: '#9CA3AF',
  sortedCellBg: '#0000000D',
  primaryRowBg: '#F8F8F8',
  alternateRowBg: '#FFFFFF',
  lowestPrice: '#FDB913',
  nearLowestPrice: '#FFEBBB',
  borderColor: '#CCCCCC',
  primaryColor: '#00798E',
  sortTextColor: '#511E62',
  floatingHeaderBg: '#FFFFFF'
};
var DEFAULT_LOCATION_ID = exports.DEFAULT_LOCATION_ID = 'ChIJdd4hrwug2EcRmSrV3Vo6llI';
var SORT_BY_VALUES = exports.SORT_BY_VALUES = {
  DISTANCE: 'distance',
  PRICE: 'price'
};